import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { RfqCacheService } from '../../dashboard/rfq-cache.service';
import { FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BuyerService } from 'src/app/views/settings/buyers/buyer.service';
import { Page } from 'src/app/shared/models/page';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { ServiceRfqTokenAuthService } from 'src/app/shared/services/service-rfq-token-auth.service';
import { Observable } from 'rxjs';
import { AutoCompleteDataType, Currency, incoterms, offeredQuality, portData, quoteAttachmentType, supplierBranchData, Vessel } from 'src/app/shared/models/settings.model';
import { v4 as uuidv4 } from "uuid";
import { NgxFileDropEntry } from 'ngx-file-drop';
import { AttachmentTypes } from 'src/app/shared/common/Enums';
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { MatRadioChange } from '@angular/material/radio';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { RfqGenerateFormService } from '../../dashboard/rfq/rfq-generate-form/rfq-genearte-form.service';
import { QuoteService } from '../../dashboard/quote/quote.service';
import { SupplierService } from 'src/app/views/settings/suppliers/supplier.service';
import { DataTransferService } from 'src/app/shared/services/data-transfer.service';

@Component({
  // Issue 7 — force Material form-field labels on this screen to float to
  // the top so they never rest over / overlap the input value.
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { floatLabel: 'always' } },
  ],
  selector: 'app-service-rfq-token-quote-payment-terms',
  templateUrl: './serviceQuotePaymentTerms.component.html',
  styleUrls: ['./serviceQuotePaymentTerms.component.css']
})
export class ServiceRfqTokenQuotePaymentTermsComponent implements OnInit{


  serviceRfqId!: number;
  quoteId!: number;
  isSaved: boolean = false;
  currentTab: string = 'payment-terms';
  tabEnabled: boolean = false;

  paymentFormGroup!: UntypedFormGroup;
  buyerFormGroup!: UntypedFormGroup;

  buyerStreet:any;
  buyerCity:any;
  buyerZipCode:any;
  buyerStateCode:any;
  buyerCountry:any;


  showNotification: boolean = false;
  notificationMessage: string = '';
  notificationTitle: string = '';
  notificationType: 'error' | 'info' = 'error';
  taxStatusData:any[]=[]

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },{
      index:3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  showConfirmationDialogue: boolean = false
  showSuccessDialogue: boolean = false
  showCloseDialogue: boolean = false;
  headerData:any;
  showDeclineConfirmationDialogue:boolean=false
  showDetailSection: boolean = false;

  paymentTermsData:any[]=[]
  paymentLeadTimeId:any;
  paymentTermsId:any;
  paymenttermsconditioncolumn:any;
  paymentTermsAndConditionAttachmentUrl:any;
  paymentTermsAndConditionsSection:boolean=false;

  buyerPaymentTermsAndConditionAttachmentUrl:any;
  buyerPaymentTermsAndConditionsSection:boolean=false;

  constructor(
    private snack: MatSnackBar,
    private rfqCacheService: RfqCacheService,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private BuyerService: BuyerService,
    private router: Router,
    private SettingsService: SettingsService,
    private fb: FormBuilder,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private ls: LocalStoreService,
    private fullLoaderService: FullLoaderService,
    private activatedRoute: ActivatedRoute,
    private RfqGenerateFormService:RfqGenerateFormService,
    private serviceRfqTokenAuth: ServiceRfqTokenAuthService,
    private quoteService: QuoteService,
    private supplierService:SupplierService,
    private dataTransferService: DataTransferService<any>

  ) {
  };


  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.getAllpaymentTerms()


    this.paymentFormGroup = this._formBuilder.group({
      supplierRfqDetailsId:[null],
      paymentTermsId:[null],
      termsAndConditions:[null],
      currencyInstructions :[null],

      billingAddress:[null],
      taxStatus:[null],
      buyerTermsAndConditions :[null],
      buyerPaymentTerms :[null],

    });

    this.buyerFormGroup = this._formBuilder.group({

      billingAddress:[null],
      taxStatus:[null],
      buyerTermsAndConditions :[null],
      buyerPaymentTerms :[null],


    });

    this.activatedRoute.queryParams.subscribe(async params => {


      if (params['serviceRfqId'] != '' && params['quoteId'] != '' ) {

        this.serviceRfqId = params['serviceRfqId']
        this.quoteId = params['quoteId']

        this.fullLoaderService.showLoader()

         this.getQuoteDraftData()


          this.fullLoaderService.hideLoader()


      }



    })
    this.fetchServiceRfqDetails()
  }

  // Function that dismisses the notification
  dismissNotification() {
    this.showNotification = false;
  }

// Function to display the notification with missing fields
showMissingFieldsNotification(missingFields: { section: string, fields: string[] }[]) {
  let message = '<strong>Please fill all the missing fields before proceeding:</strong><br><br>';

  // Loop through each section and list its missing fields
  missingFields.forEach(missingField => {
    message += `<strong>${missingField.section}:</strong><br>`; // Add section name
    message += missingField.fields.map(field => `  • ${field}`).join('<br>'); // List missing fields with bullet points
    message += '<br><br>'; // Add extra spacing between sections
  });

  this.notificationMessage = message;
  this.notificationTitle = 'Missing Fields';
  this.notificationType = 'error'; // Change this to 'info' for informational notifications
  this.showNotification = true; // Display the notification
}



  // Validation logic to check for required fields
  isValidRequiredFields(): { section: string, fields: string[] }[] {
    const missingFields: { section: string, fields: string[] }[] = [];

    // Check for missing fields in Tab3 (Payment Terms Section)
    const paymentTermsMissingFields: string[] = [];
    const paymentForm = this.paymentFormGroup;

    if (!paymentForm.get('paymentTermsId')?.value) {
      paymentTermsMissingFields.push('Payment Terms');
    }

    if (!paymentForm.get('currencyInstructions')?.value) {
      paymentTermsMissingFields.push('Currency Instructions');
    }

    if (paymentTermsMissingFields.length > 0) {
      missingFields.push({ section: 'Payment Terms', fields: paymentTermsMissingFields });
    }

    // Show notification if there are missing fields
    if (missingFields.length > 0) {
      this.showMissingFieldsNotification(missingFields);
    }

    return missingFields;
  }


  async save(isDraft?: boolean){

    if(isDraft){
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }else{
      const missingFields = this.isValidRequiredFields();
      if(missingFields.length>0){
        return;
      }
    }

    this.fullLoaderService.showLoader()

      const params = {
        section: 'tab3',
        isDraft: isDraft,
        quoteStatus: isDraft ? 14 : 2,
        quoteId: this.quoteId,
        tabId: 3,
        paymentDetails: this.paymentFormGroup.value,
        serviceRfqId: this.serviceRfqId

      };

      const result = await this.quoteService.updateServiceQuoteDraftByServiceRfqToken(params);

      if (result?.data) {

        this.fullLoaderService.hideLoader()

        this.snack.open(`Payment Terms Data Saved`, "OK", { duration: 3000 });


          if (isDraft) {
            this.snack.open('Quotation Data Saved.', 'OK', {
              duration: 1000,
            });
            this.getQuoteDraftData()
            this.router.navigate(['/serviceRfqToken/rfqDetails', this.serviceRfqId]);
          }
      }

  }

  async submit(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true

    }

  }

  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true
    }
    else {
      this.showCloseDialogue = true

    }

  }



  // close(){}

  cancel() {
    this.showConfirmationDialogue = false
    this.showCloseDialogue = false
  }

  async fetchServiceRfqDetails(){
      this.fullLoaderService.showLoader()
      let paramsData = {serviceRfqId: this.serviceRfqId, supplierId:Number(this.serviceRfqTokenAuth.getSupplierId())}
      const data = await this.quoteService.fetchServiceRfqDetailsByServiceRfqToken(paramsData)
      this.headerData = data.rfqData[0];
      console.log("Header Data ",this.headerData);

      // Nest vessel details like the header component does
      this.headerData.vessel = {
        vesselName: this.headerData.vesselName,
        imoNumber: this.headerData.vesselImoNumber,
        typeOfVessel: this.headerData.vesselType,
        class: this.headerData.vesselClass,
      };

      this.paymentFormGroup.patchValue({
        buyerPaymentTerms:this.headerData.buyerPaymentTerms || null,
      });

      this.fullLoaderService.hideLoader()
  }

  async rfqActions(action:string){

    if(action == 'download'){

    this.fullLoaderService.showLoader()

    let fileName = this.headerData?.rfqRefNumber +'.pdf';

    const pdf = await this.quoteService.generateSupplierServiceRfqAttachmentByServiceRfqToken(
      this.serviceRfqId,
      Number(this.serviceRfqTokenAuth.getSupplierId())
    )

    const uint8Array = new Uint8Array(pdf.data);
    const blob = new Blob([uint8Array], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);


    // Create a temporary <a> element
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    this.fullLoaderService.hideLoader()
    }

    else if(action == 'decline'){

      this.showDeclineConfirmationDialogue = true

    }

    else if(action == 'acknowledge'){

      this.fullLoaderService.showLoader()

      let data = {
        operation:action,
        selectedRfqId : [this.headerData.supplierRfqId]
      }

      await this.quoteService.acknowledgeServiceRfqByServiceRfqToken(data)
      this.fullLoaderService.hideLoader()
      this.snack.open('RFQ has been acknowledged', 'OK', {
        duration: 3000,
      });

    }
    this.fetchServiceRfqDetails()
  }

  async selectMatTabLink(tabItem:any){

    if(this.showNotification)return;
    if(tabItem.route == 'header'){
      await this.saveDraft();
      this.back()
    }

    else if(tabItem.route == 'line-items'){
      await this.saveDraft();
      this.router.navigate([
        '/serviceRfqToken/quote-line-items'
      ],
        {
          queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
        }
      );
    }else if(tabItem.route == 'preview'){

      const missingFields = this.isValidRequiredFields();
      if(missingFields.length>0){
        return;
      }
      await this.saveDraft();
      this.next()
    }
  }

  async next() {

    this.activatedRoute.queryParams.subscribe(async params => {

      if (params['serviceRfqId'] != '' && params['quoteId'] != '') {

        this.serviceRfqId = params['serviceRfqId']
        const quoteId = this.quoteId

        this.router.navigate([
          '/serviceRfqToken/quote-preview'
        ],
          {
            queryParams: { serviceRfqId: this.serviceRfqId, quoteId: quoteId }
          }
        );

      }

    })
  }

  async back() {

    this.router.navigate([
      '/serviceRfqToken/quote-header-details'
    ],
      {
        queryParams: { serviceRfqId: this.serviceRfqId, quoteId: this.quoteId }
      }
    );

  }
  toggleShowHeaderDetails(event: { checked: boolean }) {
    this.showDetailSection = event.checked;
  }
  toggleVisibility(section: string) {
    if (section == 'form1') {

    }
    else if (section == 'form2') {

    }


  }

  async getAllpaymentTerms(){
    this.paymentTermsData = await this.quoteService.getAllPaymentTermsByServiceRfqToken();
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true; // For data URLs, check if the MIME type is 'application/pdf'
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf'); // For URLs, check if it ends with '.pdf'
  }

  toggleBlur(): void {
    const element = document.querySelector('.blurry');
    if (element) {
      element.classList.toggle('blur');
    } else {
      console.warn('Element with class "blurry" not found.');
    }
  }

  async togglePaymentTermsAndConditionsAttachment(value:boolean){
    this.toggleBlur();
    this.paymentTermsAndConditionsSection = value;
  }

  async toggleBuyerPaymentTermsAndConditionsAttachment(value:boolean){
    this.toggleBlur();
    this.buyerPaymentTermsAndConditionsSection = value;
  }

  async getQuoteDraftData() {

    this.fullLoaderService.showLoader()

    const data = await this.quoteService.getServiceQuoteDraftDataByServiceRfqToken('tab3', this.quoteId)
    console.log(data)
    if (data && data.length > 0 && Object.keys(data[0]).length > 0) {

      console.log(data)
      this.paymentLeadTimeId=data[0].paymentLeadTimeId;
      this.paymentTermsId = data[0].paymentTermsId;
      this.paymenttermsconditioncolumn=data[0].paymenttermsconditioncolumn;
      this.paymentTermsAndConditionAttachmentUrl=data[0].s3_Path;
      this.buyerCity=data[0].buyer_city;
      this.buyerStateCode=data[0].buyer_stateCode;
      this.buyerCountry=data[0].buyer_country;
      this.buyerStreet=data[0].buyer_street;
      this.buyerZipCode=data[0].buyer_zipcode;
      const billingAddress = `${this.buyerStreet} ${this.buyerCity}, ${this.buyerStateCode} - ${this.buyerZipCode} ${this.buyerCountry}`;

      this.buyerPaymentTermsAndConditionAttachmentUrl=data[0].buyer_s3_Path;
      const taxStatusValue = data[0]?.taxStatus ? Number(data[0].taxStatus) : null;
      console.log({taxStatusValue})
      this.paymentFormGroup.patchValue({
        supplierRfqDetailsId:data[0].supplierRfqId || null,
        paymentTermsId: data[0].paymentTermsId ? Number(data[0].paymentTermsId) : null,
        termsAndConditions: data[0].termsAndConditions || null,
        currencyInstructions : data[0].currencyInstructions || null,
        billingAddress: billingAddress,
        buyerTermsAndConditions:data[0].buyer_paymenttermsconditioncolumn || null,
        taxStatus: taxStatusValue,
      });

      this.getTaxDetails(data[0].buyerId)

      this.buyerFormGroup.patchValue({
        billingAddress: billingAddress,
        buyerTermsAndConditions:data[0].buyer_paymenttermsconditioncolumn || null,
        taxStatus: taxStatusValue,
      });

      // Patch buyer payment terms with resolved name (not ID) for form textarea + sidebar
      const buyerPaymentTermsName = data[0].buyer_paymentLeadTime || null;
      this.paymentFormGroup.patchValue({
        buyerPaymentTerms: buyerPaymentTermsName,
      });
      if (this.headerData) {
        this.headerData.buyerPaymentTerms = buyerPaymentTermsName;
      }

      this.fullLoaderService.hideLoader()

    }


  }


  async getTaxDetails(buyerId:any) {
    this.fullLoaderService.showLoader();
    let data = {
      buyerId: Number(buyerId),
      userType:"buyer"
    };
    const response = await this.quoteService.getBuyerTaxDetailsByServiceRfqToken(data);
    this.taxStatusData = response.rows;
    this.fullLoaderService.hideLoader();
  }

  async saveDraft(){


    this.fullLoaderService.showLoader()

      const params = {
        section: 'tab3',
        quoteStatus: 14,
        quoteId: this.quoteId,
        tabId: 3,
        paymentDetails: this.paymentFormGroup.value,
        serviceRfqId: this.serviceRfqId

      };

      const result = await this.quoteService.updateServiceQuoteDraftByServiceRfqToken(params);

      if (result?.data) {

        this.fullLoaderService.hideLoader()

        this.snack.open(`Payment Terms Data Saved`, "OK", { duration: 3000 });

      }


  }
}
